import Vue from "vue";
import {isNil} from 'lodash';
import editVacancyStore from './index';
import Counter from "../../helpers/Counter";
import getInputsValue from './common/getInputsValue'
import filtedDisabled from './common/filterDisabled'
import getInputsComplete from './common/getInputsComplete'
import isFilledJSONValue from "../../helpers/isFilledJSONValue"
import { setDefaultInputsValues, setDefaultInputsDisabled } from './common/setDefaultInputs';
// import parseDateForLocal from "../../helpers/parseDateForLocal"
// import editVacancyStore from "./index"

const counter = new Counter()


function getInitState() {
  return {
    muted: false,
    pendingSave: false,
    sectionId: 2,
    inputs: {
      person_types: {
        value: null,
        required: false,
        check: (state) => {
          return !!(state.inputs.person_types.value?.length)
        }
      },
      // location_priority: {
      //   value: null,
      //   check: (state) => {
      //     return !!state.inputs.location_priority.value
      //   }
      // },
      // documents_for_start: {
      //   value: null,
      //   check: (state) => {
      //     let value = state.inputs.documents_for_start.value
      //     value = value && value.filter(item => item.id !== 'other')
      //     return !!(value && value.length || isFilledJSONValue(state.inputs.documents_for_start_other.value))
      //   }
      // },
      documents_for_start_other: {
        value: null
      },
      employment_types: {
        value: null,
        required: false,
        check: (state) => {
          return !!(state.inputs.employment_types.value
            && state.inputs.employment_types.value.length)
        }
      },
      experience_requirement: {
        value: null,
        check: (state) => {
          return !!state.inputs.experience_requirement.value?.id;
        }
      },
      any_age: {
        value: null
      },
      age_range: {
        value: null,
        check: (state) => {
          if (state.inputs.any_age.value && state.inputs.any_age.value.id === true) {
            return true
          }

          const range = state.inputs.age_range.value
          return !!(range && range.length)
        }
      },
      without_language: {
        value: null,
      },
      languages: [createLanguage()],
      physical_activity: {
        value: null,
        check: (state) => {
          return !!state.inputs.physical_activity.value?.id
        }
      },
      physical_activity_description: {
        value: null,
        check: (state) => {
          return isFilledJSONValue(state.inputs.physical_activity_description.value)
        },
        disabled: false,
      },
      acceptable_disability: {
        value: null,
        check: (state) => {
          const valueId = state.inputs.acceptable_disability.value?.id;
          if (isNil(valueId)) return false;
          if (valueId === true) return isFilledJSONValue(state.inputs.acceptable_disability_description.value);
          return true;
        }
      },
      acceptable_disability_description: {
        value: null,
      },
      education: {
        value: null,
        check: (state) => {
          return !!state.inputs.education.value
        }
      },
      education_description: {
        value: null,
      },
      additional_requirements: {
        value: null,
        check: (state) => {
          return isFilledJSONValue(state.inputs.additional_requirements.value)
        }
      },
      additional_required_documents: {
        value: null,
        check: (state) => {
          return isFilledJSONValue(state.inputs.additional_required_documents_comment.value)
        }
      },
      additional_required_documents_other: {
        value: null,
      },
      additional_required_documents_comment: {
        value: null,
      },
    },
  }
}

export default {
  namespaced: true,
  modules: {},
  state: getInitState(),
  mutations: {
    resetState(state) {
      Object.assign(state, getInitState())
    },
    setProperty(state, [key, value]) {
      if (!state.hasOwnProperty(key)) return

      Vue.set(state, key, value)
    },
    setInputValue(state, [key, value]) {
      Vue.set(state.inputs[key], 'value', value)
    },
    setDefaultInputsValues,
    setDefaultInputsDisabled,
    setInputError(state, [key, error]) {
      Vue.set(state.inputs[key], 'error', error)
    },
    setInputDisabled(state, [key, disabled]) {
      Vue.set(state.inputs[key], 'disabled', disabled);
    },
    setArrayInputValue(state, [key, index, itemInputKey, value]) {
      Vue.set(state.inputs[key][index][itemInputKey], 'value', value)
    },
    setArrayInputError(state, [key, index, itemInputKey, error]) {
      Vue.set(state.inputs[key][index][itemInputKey], 'error', error)
    },
    addLanguage(state) {
      state.inputs.languages.push(createLanguage())
    },
    deleteLanguage(state, index) {
      Vue.delete(state.inputs.languages, index)
    },
    deleteAllLanguages(state) {
      Vue.set(state.inputs, 'languages', [createLanguage()])
    },
    setInputsAll(state, data) {
      const sectionData = data[2]
      state.saved = true //data.saved

      for (const key in state.inputs) {
        const inputObj = state.inputs[key]
        switch (key) {
          case 'any_age': {
            if (sectionData[key]) {
              Vue.set(inputObj, 'value', editVacancyStore.state['ageTypes'][0])
            } else if (sectionData[key] === false || sectionData.age_range && sectionData.age_range.length) {
              Vue.set(inputObj, 'value', editVacancyStore.state['ageTypes'][1])
            }
            break
          }
          case 'languages': {
            if (!sectionData[key]) break
            const value = sectionData[key].map(item => {
              const l = createLanguage()
              l.language.value = item.language
              l.level.value = item.level

              return l
            })

            Vue.set(state.inputs, key, value)

            if (value.length) {
              Vue.set(state.inputs, 'without_language', { value: { id: true } })
            }

            break
          }
          case 'without_language': {
            if (typeof sectionData[key] === 'boolean') {
              Vue.set(state.inputs, 'without_language', { value: { id: sectionData[key] } })
            }
            break;
          }
          default:
            if (Array.isArray(inputObj)) {
              Vue.set(state.inputs, key, sectionData[key] || [])
            } else if (!isNil(sectionData[key])) {
              Vue.set(inputObj, 'value', sectionData[key])
            }
        }
      }

      if (isFilledJSONValue(state.inputs.documents_for_start_other.value)) {
        if (!state.inputs.documents_for_start.value) state.inputs.documents_for_start.value = []
        state.inputs.documents_for_start.value.push(editVacancyStore.state['otherDocuments'])
      }

      if (isFilledJSONValue(state.inputs.additional_required_documents_other.value)) {
        if (!state.inputs.additional_required_documents.value) state.inputs.additional_required_documents.value = []
        state.inputs.additional_required_documents.value.push(editVacancyStore.state['otherDocuments'])
      }
    },
  },
  actions: {
    setSectionErrors({state, commit}, { errors }) {
      if (typeof errors !== 'object') {
        errors = {}
      } else {
        errors = JSON.parse(JSON.stringify(errors))
      }

      for (const key in state.inputs) {
        if (Array.isArray(state.inputs[key])) {
          // debugger
          // state.inputs[key].forEach((item, index) => {
          //   commit('setArrayInputError', [key, index, 'phone', errors[key]])
          // })
        } else {
          commit('setInputError', [key, errors[key]])
        }

        delete errors[key];
      }
    },
  },
  getters: {
    complete(state) {
      let mustFilledCount = 0
      let filledCount = 0

      const inputs = state.inputs

      const result = getInputsComplete(inputs)
      mustFilledCount += result.mustFilledCount
      filledCount += result.filledCount

      return 100 / mustFilledCount * filledCount
    },
    sendData(state) {
      const data = getInputsValue(state.inputs);

      if (data.languages) {
        data.languages = data.languages.filter(v => v.language);
      }

      return filtedDisabled(data, state.inputs);
    }
  }
}

function createLanguage() {
  return {
    _id: counter.value,
    language: {
      value: null,
      check: (state, index) => {
        if(state.inputs.without_language.value && state.inputs.without_language.value.id === false) {
          return true
        }
        return !!state.inputs.languages[index].language.value?.id
      },
      translateName: 'languages'
    },
    level: {
      value: null,
    },
  }
}
